module.exports = {
  title: 'Arcanite',
}
